//useFilter.js
import { parseMutationArgs, useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import axios from "../axios";
import { useParams, useSearchParams } from "react-router-dom";
import { useTolgee } from "@tolgee/react";
import useAppState from "../store/appState";

export function useFilter() {
  const [searchWord, setSearchWord] = useState();
  const [company, setCompany] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [materials, setMaterials] = useState();
  const [activeFilters, setActiveFilters] = useState({});
  const [categories, setCategories] = useState();
  const [sortby, setSortby] = useState();
  const [companies, setCompanies] = useState();
  const [defaultCountry, setDefaultCountry] = useState();
  const [vectorSearch, setVectorSearch] = useState(localStorage["vectorSearch"] == "true");

  const { supportedLanguages } = useAppState();

  const { seriesId, companyId } = useParams();
  const tolgee = useTolgee(["language"]);

  const languageQuery = searchParams.get("lang");

  const mockMaterialsData = {
    items: [
      {
        key: 1,
        category: { key: 1, value: "Category 1" },
        series: { key: 1, value: "Series 1" },
        use: { key: 1, value: "Use 1" },
        typeOfDocument: { key: 1, value: "Document 1" },
        productCodeNumber: 123,
        lifetimeDownloads: 100,
        lastModified: "2023-01-01T00:00:00Z",
        imageURL: "/public/extensions/3d.png",
        productName: "DIRECT URL! SILENT-DUAL-Instr_Mounting2",
        isDirectUrl: true,
        downloadURL: "www.google.com",
        sizeMB: 0.0,
      },
      {
        key: 2,
        category: { key: 2, value: "Category 2" },
        series: { key: 2, value: "Series 2" },
        use: { key: 2, value: "Use 2" },
        typeOfDocument: { key: 2, value: "Document 2" },
        productCodeNumber: 124,
        lifetimeDownloads: 150,
        lastModified: "2023-02-01T00:00:00Z",
        sizeMB: 200000.2,
        imageURL: "/public/extensions/3d.png",
        productName: "SILENT-DUAL-PDF",
      },
      {
        key: 2,
        category: { key: 2, value: "Category 2" },
        series: { key: 2, value: "Series 2" },
        use: { key: 2, value: "Use 2" },
        typeOfDocument: { key: 2, value: "Document 2" },
        productCodeNumber: 124,
        lifetimeDownloads: 150,
        lastModified: "2023-02-01T00:00:00Z",
        sizeMB: 200000.2,
        imageURL: "/public/extensions/3d.png",
        productName: "SILENT-DUAL-PDF",
      },
      {
        key: 2,
        category: { key: 2, value: "Category 2" },
        series: { key: 2, value: "Series 2" },
        use: { key: 2, value: "Use 2" },
        typeOfDocument: { key: 2, value: "Document 2" },
        productCodeNumber: 124,
        lifetimeDownloads: 150,
        lastModified: "2023-02-01T00:00:00Z",
        sizeMB: 200000.2,
        imageURL: "/public/extensions/3d.png",
        productName: "SILENT-DUAL-PDF",
      },
      {
        key: 2,
        category: { key: 2, value: "Category 2" },
        series: { key: 2, value: "Series 2" },
        use: { key: 2, value: "Use 2" },
        typeOfDocument: { key: 2, value: "Document 2" },
        productCodeNumber: 124,
        lifetimeDownloads: 150,
        lastModified: "2023-02-01T00:00:00Z",
        sizeMB: 200000.2,
        imageURL: "/public/extensions/3d.png",
        productName: "SILENT-DUAL-PDF",
      },
      {
        key: 1,
        category: { key: 1, value: "Category 1" },
        series: { key: 1, value: "Series 1" },
        use: { key: 1, value: "Use 1" },
        typeOfDocument: { key: 1, value: "Document 1" },
        productCodeNumber: 123,
        lifetimeDownloads: 100,
        lastModified: "2023-01-01T00:00:00Z",
        sizeMB: 10000000,
        imageURL: "/public/extensions/3d.png",
        productName: "SILENT-DUAL-Instr_Mounting2",
      },
    ],
    total: 2,
  };

  let seriesAndDocuments = null;

  useEffect(() => {
    localStorage.setItem("vectorSearch", vectorSearch);
  }, [vectorSearch]);

  useEffect(() => {
    setSearchWord(searchParams.get("searchTerm"));
    //setVectorSearch(searchParams.get("smartSearch"));
    setCompany(searchParams.get("companyId"));
  }, [searchParams, languageQuery]);

  function getLanguageKey() {
    var languageCode = tolgee.getLanguage();
    return supportedLanguages.find((l) => l.languageCode == languageCode)?.languageNumber ?? 0;
  }

  useEffect(() => {
    if (!companies && localStorage["disd"]) {
      async function getData() {
        const response = await axios.get("/materials/companies", {
          headers: {
            disd: localStorage["disd"],
          },
        });

        setCompanies(response.data);
      }

      getData();
    }
  }, []);

  const { data, isFetching } = useQuery(
    ["search", searchWord, company, vectorSearch, seriesId, languageQuery],
    async () => {
      const backendIsDown = false;

      const forceEnglish = typeof window !== "undefined" && sessionStorage.getItem("englishOnce") === "1";

      const languageParam = forceEnglish ? 1 : languageQuery ? Number(languageQuery) : getLanguageKey();

      try {
        sessionStorage.setItem("englishActive", String(languageParam === 1 ? "1" : "0"));
      } catch {}

      // optional sanity log while debugging
      // console.log({ forceEnglish, languageParam, languageQuery, tolgee: tolgee.getLanguage?.() });

      if (backendIsDown) {
        return new Promise((resolve) => {
          setTimeout(() => resolve(mockMaterialsData), 1);
        });
      } else {
        const response = await axios.get("/materials", {
          params: {
            filter: {
              searchTerm: searchWord,
              language: languageParam,
              seriesId: seriesId,
              companyId: company || companyId,
              vectorSearch: vectorSearch || false,
            },
            page: { pageNumber: 1, pageSize: 9999 },
          },
          headers: {
            disd: localStorage["disd"],
          },
        });

        // clear the one-shot flag AFTER this fetch completes
        // if (forceEnglish) {
        //   try {
        //     sessionStorage.removeItem("englishOnce");
        //   } catch {}
        // }

        setDefaultCountry(response.data?.meta);
        return response.data;
      }
    },
    {
      select: (data) => {
        seriesAndDocuments = null;
        if (data == null || data.total === 0) {
          return [];
        } else {
          seriesAndDocuments = data.detectedAssetTypes;
          return data.items;
        }
      },
      enabled: seriesId !== undefined || (searchWord !== undefined && searchWord !== null && searchWord !== ""),
      retry: (failureCount, error) => error.response?.status !== 400,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  useEffect(() => {
    setMaterials(null);
    //setActiveFilters({});

    const forceEnglish = typeof window !== "undefined" && sessionStorage.getItem("englishOnce") === "1";

    if (!forceEnglish) {
      setActiveFilters({});
    }

    if (forceEnglish) {
      try {
        sessionStorage.removeItem("englishOnce");
      } catch {}
    }

    if (!data) {
      return;
    }

    setMaterials(filterMaterials(data));

    const productCategories = removeDuplicates(data.map((m) => m.category) ?? []);
    const series = removeDuplicates(data.map((m) => m.series) ?? []);

    const uses = removeDuplicates(data.map((m) => m.use) ?? []);
    const typeOfDocuments = removeDuplicates(data.map((m) => m.typeOfDocument) ?? []);

    // typeOfDocuments.forEach((doc) => {
    //   doc.value = tolgee.t(`TipoDocumental.${doc.key}`, doc.value);
    // });

    if (seriesId) {
      // reorder filters if came in via route, and pre-apply 'most important' filters
      setCategories({ typeOfDocument: typeOfDocuments, use: uses, category: productCategories, series });
      setActiveFilters({ ...activeFilters, typeOfDocument: [3, 11, 39, 56] });
    } else {
      setCategories({ typeOfDocument: typeOfDocuments, use: uses, category: productCategories, series });
      if (seriesAndDocuments?.length > 0) {
        setActiveFilters({ ...activeFilters, typeOfDocument: seriesAndDocuments });
      }
    }
  }, [data]);

  useEffect(() => {
    if (data) setMaterials(filterMaterials(data));
  }, [activeFilters, sortby]);

  function removeDuplicatesAndAddSeries(data, propertyName) {
    const categoryWithSeries = {};

    data.forEach((item) => {
      const categoryType = item[propertyName].key;
      const series = item.series;

      if (!categoryWithSeries[categoryType]) {
        categoryWithSeries[categoryType] = {};
        categoryWithSeries[categoryType].series = [];
        categoryWithSeries[categoryType].value = item.typeOfDocument.value;
      }

      if (!categoryWithSeries[categoryType].series.some((s) => s.key == series.key)) {
        categoryWithSeries[categoryType].series.push(series);
      }
    });

    return Object.entries(categoryWithSeries).map(([key, value]) => ({
      key: parseInt(key),
      value: value.value,
      series: value.series,
    }));
  }

  function removeDuplicates(arr) {
    let unique = arr.reduce(function (acc, curr) {
      if (!acc.some((a) => a.key == curr.key)) acc.push(curr);
      return acc;
    }, []);
    return unique;
  }

  const filterMaterials = (data) => {
    const filteredResults = data.filter((material) => {
      const matches = Object.entries(activeFilters).every(([category, selectedItems]) => {
        return selectedItems.length === 0 || selectedItems.includes(material[category].key);
      });
      return matches;
    });

    if (sortby === "popular") {
      filteredResults.sort((a, b) => b.lifetimeDownloads - a.lifetimeDownloads);
    } else if (sortby === "newest") {
      filteredResults.sort((a, b) => new Date(b.lastModified).getTime() - new Date(a.lastModified).getTime());
    } else {
      filteredResults.sort((a, b) => b.priority - a.priority);
    }

    return filteredResults;
  };

  return {
    searchWord,
    setSearchWord,
    materials,
    activeFilters,
    setActiveFilters,
    sortby,
    setSortby,
    categories,
    isFetching,
    companies,
    data,
    defaultCountry,
    vectorSearch,
    setVectorSearch,
  };
}
